import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarServiceService {

  private sidebarState: boolean = false;
   private notificationState: boolean = false;
  constructor() { }
  toggleSidebar() {
    this.sidebarState = !this.sidebarState;
  }

  getSidebarState() {
    return this.sidebarState;
  }

  toggleNotification() {
    this.notificationState = !this.notificationState;
  }

  getNotificationState() {
    return this.notificationState;
  }


}
